import { takeLatest, put, select } from 'redux-saga/effects';
import { actions as busNfcReportAction } from '../slices/SoldTicketSlice';
import NetworkHandler from 'utils/network';
import config from 'config';
import NotificationHandler from 'utils/notification';
import { call } from 'redux-saga/effects';

const getSearchCriteria = (state) => state.reportTicketHistory.searchCriteria;


function* getSoldTicketTrackings({ payload: { page, size, filters } }) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('sold_ticket')}`, {
            params: {
                ...filters,
                page: page ? page - 1 : null,
                size: size,
            },
        });
        yield put({ type: busNfcReportAction.get_list_succeed.type, payload: { ...response.data } });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: busNfcReportAction.get_list_failed.type, payload: error });
    }
}

function* updateTrackingStatus({ payload: { page, size, trackingId, filters } }) {
    try {
        yield NetworkHandler.put(`${config.getUrl('sold_ticket')}/${trackingId}`, {
        });

        const action = { filters, page, size };
        yield call(getSoldTicketTrackings, { payload: action });

    } catch (error) {
        NotificationHandler.notifyError(error.message);
        const action = { filters, page, size };
        yield call(getSoldTicketTrackings, { payload: action });
    }
}


function* watchRequestDetail() {
    yield takeLatest(busNfcReportAction.get_list.type, getSoldTicketTrackings);
    yield takeLatest(busNfcReportAction.update_tracking_status.type, updateTrackingStatus);

}

export default watchRequestDetail;
